module.exports = __webpack_public_path__ + "static/HF_LFSSC-ca9ffc54c767a4f124c3276aadb8476d.png";